import React from "react";

interface PriceBlockIconProps {
  color?: string;
}

export const PriceBlockIcon = ({ color = "#94A3B8" }: PriceBlockIconProps) => (
  <svg
    width="11"
    height="11"
    viewBox="0 0 11 11"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <circle cx="5.5" cy="5.5" r="4.4" stroke={color} strokeWidth="1.1" />
    <path d="M2.4 2.4L8.6 8.6" stroke={color} strokeWidth="1.1" strokeLinecap="round" />
  </svg>
);
